export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8983.269cc5d0.jpg";